export function CircleCheck() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6ZM7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.85355 7.35355C5.65829 7.54882 5.34171 7.54882 5.14645 7.35355L4.14645 6.35355C3.95118 6.15829 3.95118 5.84171 4.14645 5.64645C4.34171 5.45118 4.65829 5.45118 4.85355 5.64645L5.5 6.29289L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645Z"
                fill="#96F2D7"
            />
        </svg>
    );
}
